import {
  faPlus,
  faRefresh,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ShoppingCartItem } from "@mjolnerbacken/shared/types/shopping-cart-item";
import { useRef, useState } from "react";

import { Input } from "../components/input";
import { PrimeButton } from "../components/prime/button";
import { ShoppingItem } from "../components/shopping-item";
import { useShoppingCart } from "../hooks/shopping-cart";
import { sortArray } from "../utils/sort-array";

export function ShoppingList({ className }: { className?: string }) {
  const {
    data: shoppingCart,
    isInvalidating: isPendingShoppingCart,
    createItem: createShoppingCartItem,
    isCreating: isCreatingShoppingCartItem,
    invalidateQuery: invalidateShoppingCart,
  } = useShoppingCart();
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={className}>
      <h2 className="flex gap-2 text-xl mb-4">
        Shopping List
        <PrimeButton
          disabled={isPendingShoppingCart}
          icon={
            <FontAwesomeIcon icon={faRefresh} spin={isPendingShoppingCart} />
          }
          severity="success"
          size="small"
          onClick={() => {
            (async () => {
              await invalidateShoppingCart();
            })();
          }}
        />
      </h2>
      <div className="relative">
        {isPendingShoppingCart && shoppingCart && shoppingCart.length > 0 && (
          <div className="w-full h-full bg-gray-50/70 absolute top-0 left-0 z-1 flex items-center justify-center">
            <FontAwesomeIcon
              pulse
              className="text-gray-500"
              icon={faSpinner}
              size="4x"
            />
          </div>
        )}
        <form
          className="flex items-center gap-4 px-3 py-2 bg-gray-50 shadow-sm mb-2"
          onSubmit={(e) => {
            e.preventDefault();
            createShoppingCartItem(
              {
                value: inputValue.trim(),
                checked: false,
              },
              {
                onSuccess: () => {
                  setInputValue("");
                  setTimeout(() => {
                    inputRef.current?.focus();
                  }, 1);
                },
              },
            );
          }}
        >
          <Input
            ref={inputRef}
            autoComplete="off"
            className="flex-1"
            disabled={isCreatingShoppingCartItem}
            inputClassName="w-full"
            size="small"
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
          <PrimeButton
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
            disabled={inputValue.trim().length === 0}
            icon={<FontAwesomeIcon icon={faPlus} size="xs" />}
            loading={isCreatingShoppingCartItem}
            size="small"
            type="submit"
          />
        </form>
        {shoppingCart && (
          <ul className="space-y-2">
            {sortShoppingCart(shoppingCart).map((item) => (
              <ShoppingItem key={item.id} item={item} />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

// Sort shoppingcart by checked and then by createdAt
function sortShoppingCart(
  shoppingCart: ShoppingCartItem[],
): ShoppingCartItem[] {
  return sortArray([...shoppingCart], ["createdAt"], "desc");
}
